import React from 'react';

const AuthCloseIconSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.41699 5.41669L14.5837 14.5834" stroke="white" stroke-width="1.3"/>
    <path d="M14.583 5.41669L5.41634 14.5834" stroke="white" stroke-width="1.3"/>
  </svg>

);

export default AuthCloseIconSvg;